import React, { MouseEvent } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../constants/aampeTheme';
//icons
import ICONS from '../../../constants/icons';

import AampeItalicText from '../../shared/AampeText/AampeItalicText';
// components
import AampeTooltip, {
    TooltipPlacement,
} from '../../shared/AampeTooltip/AampeTooltip';

interface TextWithInfoTooltipProps {
    text: string;
    description?: React.ReactNode | string;
    onClick?: (event: MouseEvent<HTMLDivElement>) => void;
    className?: string;
    tooltipPlacement?: TooltipPlacement;
    isRequired?: boolean;
}

interface StyledProps {
    isClickable?: boolean;
}

const TextWithInfoTooltip: React.FC<
    React.PropsWithChildren<TextWithInfoTooltipProps>
> = ({
    text,
    description,
    onClick,
    className,
    tooltipPlacement = 'top',
    isRequired,
}) => {
    return (
        <Container onClick={onClick} className={className}>
            {text}
            {description && (
                <AampeTooltip
                    title={description}
                    arrow
                    placement={tooltipPlacement}
                >
                    <Icon isClickable={!!onClick}>
                        <ICONS.info size={16} />
                    </Icon>
                </AampeTooltip>
            )}
            {isRequired && <AampeItalicText text="(Required)" />}
        </Container>
    );
};

const Container = styled.div(() => ({
    display: 'flex',
    gap: aampeTheme.spacing(1),
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: aampeTheme.spacing(2),
}));

const Icon = styled('div').withConfig({
    shouldForwardProp: (prop) => prop !== 'isClickable',
})<StyledProps>(({ isClickable }) => ({
    color: aampeTheme.colors.neutral09,
    marginTop: aampeTheme.spacing(0.5),
    cursor: isClickable ? 'pointer' : 'default',
}));

export default TextWithInfoTooltip;
